import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus } from './redux/FeedbackRedux';


class Alert extends React.Component {

	render () {
		if (this.props.alert.alert && this.props.alert.alert_location == this.props.location) {
			return ( 
				<h6 className={"alert mb-3 text-center alert-"+this.props.alert.alert_class}>{this.props.alert.alert_message}</h6>
			);
		} else {
			return (
				null
			);
		}
	}
}

export default Alert;
// function mapStateToProps(state) {
// 	return { state:state }
// }

// export default connect(mapStateToProps)(FeedbackList)